import { BotFeatures } from '@feedyou-ai/feedbot-schema'
import { useDispatch, useSelector } from 'react-redux'
import { migrateLegacyVariablesToGlobalStorages } from '@features/storages'

import { actions as featuresSliceActions } from '../../../store/features/featuresSlice'
import { devToolsSliceActions, ForcedBotFeatures } from '../devToolsSlice'
import { FeatureValues } from '../../../store/features/types'
import { useWindowDebugParams } from './useWindowDebugParams'
import { featuresSchema } from '../../../store/features/featuresSchema'
import { forcedBotFeaturesSelector } from '../selectors'
import { enableAllBooleanFeatures } from '../actions'
import { dialogHierarchyMapSelector } from '../../../store/flow/selectors/dialogHierarchyMapSelector'

export const useWindowParams = () => {
  const dispatch = useDispatch()
  const dialogHierarchy = useSelector(dialogHierarchyMapSelector)

  ;(window as any).migrateLegacyVariables = () => dispatch(migrateLegacyVariablesToGlobalStorages())

  useWindowDebugParams({
    setFeatures: (features: FeatureValues) =>
      dispatch(
        featuresSliceActions.setFeatureValues({ set: 'devForcedFeatures', values: features })
      ),
    enableAllBooleanFeatures: () => dispatch(enableAllBooleanFeatures()),

    possibleFeatures: featuresSchema
  })

  useWindowDebugParams({
    setForcedBotFeatures: (features: ForcedBotFeatures) =>
      dispatch(devToolsSliceActions.setForcedBotFeatures(features)),
    currentForcedBotFeatures: useSelector(forcedBotFeaturesSelector),
    currentBotFeatures: useSelector((store: any) => store?.app?.present?.sdkFeatures),
    possibleBotFeatures: Object.values(BotFeatures)
  })

  useWindowDebugParams({
    getDialogHierarchy: () => dialogHierarchy
  })
}
